<!-- 條款：/terms -->
<template>
  <div class="layout_wrapper">
    <div class="container_wrapper">
      <h2 class="page_main_title">
        {{ termTitle }}
      </h2>

      <div
        class="terms_content"
        v-html="term"
      />
    </div>

    <component :is="dialogName" />
  </div>
</template>

<script>
import { ref, computed, onMounted } from 'vue';
import { AppDialog } from '@/components/Modal/';
import { getPolicyDetail } from '@/libs/API/apis';
import { onBeforeRouteUpdate } from 'vue-router';
import useCommon from '@/libs/globalComposition';

const termTitleList = {
  usage: '使用者服務條款',
  privacy: '隱私權條款',
  appointedStore: '特約機構特別約定條款',
  serviceTerms: '服務規範'
};

export default {
  name: 'Terms',
  components: {
    AppDialog
  },
  setup () {
    const { currentRoute, dialogName } = useCommon();

    const termType = ref(currentRoute.params.type || 'usage');
    const term = ref('');

    const termTitle = computed(() => termTitleList[termType.value]);

    const getPolicyData = () => {
      getPolicyDetail(termType.value)
        .then((res) => {
          term.value = res;
        });
    };

    onMounted(() => {
      onBeforeRouteUpdate((to, from) => {
        termType.value = to.params.type;
        getPolicyData();
      });

      getPolicyData();
    });

    return {
      dialogName,
      termTitleList,
      termTitle,
      term
    };
  }
};
</script>

<style scoped lang="scss">
@import '@/scss/common/common.scss';
@import '@/scss/common/layout.scss';

.layout_wrapper {
  .container_wrapper {
    .terms_content {
      @include font-size-18;

      color: $mono_80;
      white-space: pre-wrap;
      word-wrap: break-word;

      &:last-of-type {
        margin-bottom: 0px;
      }
    }
  }
}

@include RWD_414 {
  .layout_wrapper {
    .container_wrapper {
      .terms_content {
        @include font-size-16;
      }
    }
  }
}
</style>
